<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>积分商品</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-card class="box-card" style="margin-bottom: 20px;">
			<el-form :inline="true" class="user-search" :model="formInline">
				<el-form-item label="商品名称：">
					<el-input size="small" placeholder="请输入商品名称" v-model="formInline.goodsName" clearable></el-input>
				</el-form-item>
				<el-form-item label="售价区间：">
					<el-input size="small" placeholder="售价最小值" v-model="formInline.salePriceMin" clearable style="width: 150px;"></el-input>
					<el-input size="small" placeholder="售价最大值" v-model="formInline.salePriceMax" clearable style="width: 150px;"></el-input>
				</el-form-item>
				<el-form-item label="积分区间：">
					<el-input size="small" placeholder="积分最小值" v-model="formInline.exchangePointsMin" clearable style="width: 150px;"></el-input>
					<el-input size="small" placeholder="积分最大值" v-model="formInline.exchangePointsMax" clearable style="width: 150px;"></el-input>
				</el-form-item>
				<el-form-item label="兑换开始日期区间：">
					<datatime v-model="formInline.exchangeStartTimeStart" catename="exchangeStartTimeStart"></datatime>
					<datatime v-model="formInline.exchangeStartTimEnd" catename="exchangeStartTimEnd"></datatime>
				</el-form-item>
				<el-form-item label="兑换截止日期区间：">
					<datatime v-model="formInline.exchangeEndTimeStart" catename="exchangeEndTimeStart"></datatime>
					<datatime v-model="formInline.exchangeEndTimeEnd" catename="exchangeEndTimeEnd"></datatime>
				</el-form-item>
				<!-- <el-form-item label="奖品等级：">
					<el-select v-model="formInline.goodsLevel" placeholder="选择奖品等级" style="width: 150px;" clearable>
						<el-option :label="item" :value="item" v-for="item in 10" :key="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="奖品类别：">
					<el-select v-model="formInline.rankType" placeholder="选择奖品类别" style="width: 150px;" clearable>
						<el-option :label="item.name" :value="item.status" v-for="(item,index) in rankType"
							:key="index"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="danger" icon="el-icon-plus" @click="handleadd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column type="index" width="50" align="center"> </el-table-column>
			<el-table-column prop="goodsName" label="商品名称" align="center"> </el-table-column>
			<el-table-column prop="lastVersion" label="商品图片" align="center">
				<template slot-scope="scope">
					<el-image style="width: 60px;height: 60px;" :src="scope.row.coverImg"
						:preview-src-list="[scope.row.coverImg]">
					</el-image>
				</template>
			</el-table-column>
			<el-table-column prop="des" label="商品描述" align="center">

			</el-table-column>
			<el-table-column prop="exchangedInit" label="商品数量" align="center">
			
			</el-table-column>
			<el-table-column prop="purchaseLimit" label="商品限购数" align="center">
			
			</el-table-column>
			<el-table-column prop="exchangePoints" label="商品积分" align="center">

			</el-table-column>
			<el-table-column prop="salePrice" label="商品价值" align="center">
			
			</el-table-column>
			<!-- <el-table-column prop="lastVersion" label="奖品类型" align="center">
				<template slot-scope="scope">
					{{scope.row.rankType == 'week'?'周':(scope.row.rankType == 'month'?'月':'年')}}
				</template>
			</el-table-column> -->
			<el-table-column prop="lastVersion" label="兑换时间" align="center">
				<template slot-scope="scope">
					{{web.formatTime(scope.row.exchangeStartTime,'Y-M-D h:m')}}
					~~
					{{web.formatTime(scope.row.exchangeEndTime,'Y-M-D h:m')}}
				</template>
			</el-table-column>
			<!-- <el-table-column label="获奖用户" align="center">
				<template slot-scope="scope">
					{{scope.row.username?scope.row.username:'--'}}
				</template>
			</el-table-column>
			<el-table-column label="用户头像" align="center">
				<template slot-scope="scope">
					<el-image v-if="scope.row.userHead" style="width: 60px;height: 60px;" :src="scope.row.userHead"
						:preview-src-list="[scope.row.userHead]">
					</el-image>
					<div v-else>--</div>
				</template>
			</el-table-column> -->
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleedit(scope.row)">
						编辑
					</el-button>
					<el-button size="mini" @click="handledelete(scope.row)">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
		<!-- 弹框 设代理和设置会员-->
		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible" width="500px">
			<el-form label-width="120px">
				<el-form-item label="商品名称:">
					<el-input v-model="editForm.goodsName" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="商品描述:">
					<el-input v-model="editForm.des" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="积分:">
					<el-input v-model="editForm.exchangePoints" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="商品价值:">
					<el-input v-model="editForm.salePrice" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="商品限购数:">
					<el-input v-model="editForm.purchaseLimit" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="商品初始数:">
					<el-input v-model="editForm.exchangedInit" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="兑换开始时间：">
					<datatime v-model="editForm.exchangeStartTime" catename="exchangeStartTime"></datatime>
				</el-form-item>
				<el-form-item label="兑换结束时间：">
					<datatime v-model="editForm.exchangeEndTime" catename="exchangeEndTime"></datatime>
				</el-form-item>
				<el-form-item label="列表页展示图:">
					<uploadone :url="editForm.coverImg" cateName="coverImg" @click="uploadone"></uploadone>
				</el-form-item>
				<el-form-item label="详情轮播图">
					<uploadMore :imgstr="editForm.bannerImg" cateName="bannerImg" csssize="100px" @click="uploadone">
					</uploadMore>
				</el-form-item>
				<quill-editor ref="text" v-model="editForm.details" class="myQuillEditor" :options="editorOption" />
			</el-form>
			<span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitedit">提交</el-button>

			</span>
		</el-dialog>


	</div>
</template>

<script>
	import {
		delPointsGoods,
		addPointsGoods,
		getPointsGoods
	} from '../../api/basisMG.js'
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import uploadone from '@/components/uploadone'
	import uploadMore from '../../components/uploadMore'
	// import uploadwgt from '@/components/uploadwgt'
	// 导出模块
	export default {
		components: {
			// uploadwgt,
			uploadone,
			uploadMore
		},

		// 模块数据
		data() {
			//数据  
			return {
				editorOption: {} ,
				editbj:{},
				rankType: [{
						name: '周',
						status: 'week'
					},
					{
						name: '月',
						status: 'month'
					},
					{
						name: '年',
						status: 'year'
					},
				],
				goodsImg: '',
				loading: true,
				visible: false,
				listData: [],
				dialogVisible: false,
				formInline: {
					start: 0,
					length: 10
				},
				editForm: {},
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 10,
					start: 0,
					length: 10
				},
			}
		},


		watch: {},

		methods: {
			uploadone(data, cateName) {
			
				this.editForm[cateName] = data
			},
			handleUpload(url) {
				// this.editForm.wgtUrl = url
				this.$set(this.editForm, 'wgtUrl', url)
				console.log(this.editForm.wgtUrl)
			},
			handleUpload1(url) {
				this.$set(this.editForm, 'pkgUrl', url)
				// this.editForm.pkgUrl = url
				console.log(this.editForm.wgtUrl1)
			},
			handleadd() {
				this.dialogVisible = true
				this.editForm = {}

			},
			handleedit(row) {
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
			handledelete(row) {
				this.$confirm('确认删除吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delPointsGoods({
						goodsId: row.goodsId
					}).then(res => {
						if (res.code == '200') {
							this.$message({
								message: '删除成功',
								type: 'success'
							})
							this.getdata()
						}

					})
				})

			},
			submitedit() {
				let param = this.editForm
				// param.upgradeId = this.editForm.id
				this.$confirm('确认提交吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					addPointsGoods(param).then(res => {
						console.log(res)
						if (res.code == '200') {
							this.$message({
								message: '提交成功',
								type: 'success'
							})
							this.dialogVisible = false
							this.getdata()
						}

					})

				})

			},
			getdata() {
				getPointsGoods(this.formInline).then(res => {
					this.saveParams(this.$route.path,this.formInline)
					if (res.code == 200) {
						this.listData = res.data.content
						this.loading = false
						this.pageparm.total = res.data.totalElements
					}
				})
			},
			// 分页插件事件
			callFather(parm) {
				this.pageparm.currentPage = parm.currentPage
				this.pageparm.pageSize = parm.pageSize
				this.pageparm.start = parm.currentPage - 1
				this.pageparm.length = parm.pageSize
				this.formInline.start = parm.currentPage - 1
				this.formInline.length = parm.pageSize
				this.getdata(this.formInline)
			},
		},
		// 创建前状态(里面是操作)
		beforeCreate() {},
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() {},
		// 挂载结束状态(里面是操作)
		mounted() {},
		// 更新前状态(里面是操作)
		beforeUpdate() {},
		// 更新完成状态(里面是操作)
		updated() {},
		// 销毁前状态(里面是操作)
		beforeDestroy() {},
		// 销毁完成状态(里面是操作)
		destroyed() {}
	};
</script>

<style scoped>

</style>
